module.exports = __webpack_public_path__ + "img/facebook.7a2c857a.png";